export const loadAppConfig = async () => {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_BASE}/app-config.js`);
    const text = await res.text();
    eval(text);

    const cfg = window.__APP_CONFIG__ || {};

    document.title = cfg.shortName || "Admin";

    const desc = document.getElementById("meta-description");
    if (desc) desc.content = cfg.description || "";

    const author = document.getElementById("meta-author");
    if (author) author.content = cfg.author || "";

    const favicon = document.getElementById("app-favicon");
    favicon.href = cfg.favicon
  ? `${process.env.REACT_APP_API_BASE}${cfg.favicon}?v=${Date.now()}`
  : "/favicon.ico";
  } catch (err) {
    console.error("Failed to load app config", err);
  }
};